import type { ValidationCode } from '@pfo/domain';

/**
 * One Vietnamese sentence per domain validation code. The codes come from
 * `packages/domain`, which knows the rules but not the language (skill 13 — the family
 * never reads a code).
 */
export const VALIDATION_MESSAGES: Record<ValidationCode, string> = {
  REQUIRED: 'Vui lòng nhập thông tin này.',
  TOO_LONG: 'Tên quá dài — tối đa 80 ký tự.',
  INVALID_VALUE: 'Giá trị này không hợp lệ.',
  NOT_INTEGER: 'Số tiền phải là số nguyên đồng.',
  NEGATIVE_AMOUNT: 'Số tiền không được là số âm. Khoản nợ nhập số tiền còn nợ.',
};
